/* Gulf Poly Pipe — site interactivity (progressive enhancement) */
(function () {
  "use strict";
  var doc = document;

  /* Sticky header shadow on scroll */
  var hdr = doc.getElementById("hdr");
  function onScroll() { if (hdr) hdr.classList.toggle("scrolled", window.scrollY > 8); }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* Mobile menu */
  var burger = doc.getElementById("burger");
  var nav = doc.getElementById("navLinks");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      burger.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      doc.body.style.overflow = open ? "hidden" : "";
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("open");
        burger.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
        doc.body.style.overflow = "";
      });
    });
  }

  /* Reveal-on-scroll with safe fallback (never leave content hidden) */
  var els = [].slice.call(doc.querySelectorAll(".reveal"));
  function showAll() { els.forEach(function (e) { e.classList.add("in"); }); }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
    /* Safety net: reveal anything still hidden shortly after load */
    window.addEventListener("load", function () {
      setTimeout(function () {
        els.forEach(function (e) {
          var r = e.getBoundingClientRect();
          if (r.top < window.innerHeight * 1.1) e.classList.add("in");
        });
      }, 400);
    });
  } else { showAll(); }

  /* Current year in footer */
  var y = doc.getElementById("yr"); if (y) y.textContent = new Date().getFullYear();
})();

/* Pipe finder + RFQ form validation */
(function () {
  "use strict";
  var d = document, $ = function (id) { return d.getElementById(id); };
  // Pipe finder (geometry + weight; PE4710, reference only)
  var sz = $("pf-size"), dr = $("pf-dr"), ln = $("pf-len");
  function set(id, v) { var e = $(id); if (e) e.textContent = v; }
  function calc() {
    if (!sz || !dr) return;
    var od = parseFloat(sz.value), DR = parseFloat(dr.value), L = parseFloat(ln && ln.value) || 0;
    var wall = od / DR, id = od - 2 * wall, wt = 0.3270 * (od * od - id * id);
    set("pf-od", od.toFixed(3)); set("pf-wall", wall.toFixed(3));
    set("pf-id", id.toFixed(3)); set("pf-wt", wt.toFixed(2));
    set("pf-total", Math.round(wt * L).toLocaleString()); set("pf-lenlabel", L || 0);
    set("pf-press", Math.round(2000 / (DR - 1)));
  }
  if (sz) { ["change", "input"].forEach(function (ev) { sz.addEventListener(ev, calc); dr.addEventListener(ev, calc); if (ln) ln.addEventListener(ev, calc); }); calc(); }
  // RFQ form: inline validation + success state
  var form = d.querySelector("form.rfq");
  if (form) {
    form.addEventListener("submit", function (e) {
      var ok = true;
      form.querySelectorAll("[required]").forEach(function (f) {
        var bad = !f.value.trim() || (f.type === "email" && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.value));
        f.classList.toggle("bad", bad); f.parentElement.classList.toggle("bad", bad);
        if (bad) ok = false;
      });
      if (!ok) { e.preventDefault(); var fb = form.querySelector(".bad"); if (fb && fb.focus) fb.focus(); return; }
      var okmsg = $("form-ok"); if (okmsg) { okmsg.classList.add("show"); okmsg.scrollIntoView({ behavior: "smooth", block: "center" }); }
    });
  }
})();
